
export enum Region {
  BR = "BR",
  EUNE = "EUNE",
  EUW = "EUW",
  JP = "JP",
  KR = "KR",
  LAN = "LAN",
  LAS = "LAS",
  NA = "NA",
  OCE = "OCE",
  RU = "RU",
  TR = "TR",
  TW2 = "TW2",
  CHN = "CHN",
  ME = "ME",
}
import colors from 'tailwindcss/colors'
export const regions = Object.values(Region)
// Maps region to color 500
export const REGION_COLORS = {
  [Region.EUW]: '#6B9AC4', // noway-muted-blue
  [Region.NA]: '#8FA3B8', // noway-muted-slate
  [Region.KR]: '#A2E0C9', // noway-default
  [Region.EUNE]: '#7FB3A7', // noway-muted-teal
  [Region.BR]: '#9BC4AF', // noway-muted-mint
  [Region.JP]: '#E6FAF2', // noway-light
  [Region.LAN]: '#6B9AC4', // noway-muted-blue
  [Region.LAS]: '#8FA3B8', // noway-muted-slate
  [Region.OCE]: '#7FB3A7', // noway-muted-teal
  [Region.RU]: '#40514F', // noway-dark
  [Region.TR]: '#9BC4AF', // noway-muted-mint
  [Region.TW2]: '#A2E0C9', // noway-default
  [Region.ME]: '#34D399', // noway-mint / emerald
  'ME1': '#34D399',
  'MEA': '#34D399',
  'KOR': '#A2E0C9', // noway-default
  'LA1': '#6B9AC4', // noway-muted-blue
  'LA2': '#8FA3B8', // noway-muted-slate
  'RUS': '#40514F', // noway-dark
  'EUN': '#7FB3A7', // noway-muted-teal
  'TUR': '#9BC4AF', // noway-muted-mint
  'JPN': '#E6FAF2', // noway-light
  'CHN': '#A2E0C9', // noway-default
}

export const REGION_NAMES: { [key: string]: string } = {
  'EUW': 'Europe West',
  'NA': 'North America',
  'KR': 'Korea',
  'EUNE': 'Europe Nordic & East',
  'BR': 'Brazil',
  'JP': 'Japan',
  'LAN': 'Latin America North',
  'LAS': 'Latin America South',
  'OCE': 'Oceania',
  'RU': 'Russia',
  'TR': 'Turkey',
  'ME': 'Middle East',
  'ME1': 'Middle East',
  'MEA': 'Middle East',
  'KOR': 'Korea',
  'LA1': 'Latin America North',
  'LA2': 'Latin America South',
  'RUS': 'Russia',
  'EUN': 'Europe Nordic & East',
  'TUR': 'Turkey',
  'JPN': 'Japan',
  'TW2': 'Taiwan',
  'CHN': 'China',
};

export const convertErrorsInRegionToActualRegionForMap = (region: string): Region => {
  switch (region.toUpperCase()) {
    case "BR1":
    case "BRA":
    case "BRAZIL":
      return Region.BR;
    case "EUN1":
    case "EUNE":
    case "EUN":
      return Region.EUNE;
    case "EUW1":
    case "EUW":
      return Region.EUW;
    case "JP1":
    case "JP":
    case "JAP":
      return Region.JP;
    case "KR":
    case "KR1":
    case "KOR":
      return Region.KR;
    case "LA1":
    case "LAN":
      return Region.LAN;
    case "LA2":
    case "LAS":
      return Region.LAS;
    case "NA1":
      return Region.NA;
    case "OC1":
    case "OCE":
    case "OCE1":
      return Region.OCE;
    case "RU":
    case "RUS":
      return Region.RU;
    case "TR1":
    case "TRK":
    case "TUR":
      return Region.TR;
    case "ME":
    case "ME1":
    case "MEA":
    case "ARAB":
    case "ARABIC":
    case "SA":
      return Region.ME;
    default:
      return region as Region
  }
}

